export default __webpack_public_path__ + "static/media/06-VEH-(3-2).8a159443.jpg";